import DefaultTable from "./default-table";
import MeetingTable from "./meeting-table";
import UniProgramsTable from "./uni-programs-table";

export default {
  DefaultTable,
  MeetingTable,
  UniProgramsTable,
};
